import {
  Module, VuexModule, Mutation, Action
} from 'vuex-module-decorators';
import api from '@/api/invitecode';

@Module({ namespaced: true })
export default class extends VuexModule {
  @Action
  async list(params: any) {
    return api.list(params);
  }

  @Action
  async logs(params: any) {
    return api.logs(params);
  }

  @Action
  async send(params: any) {
    return api.send(params);
  }

  @Action
  async detail(params: any) {
    return api.detail(params);
  }

  @Action
  async edit(params: any) {
    return api.edit(params);
  }
}
